import { render, staticRenderFns } from "./a-bundle-radio.vue?vue&type=template&id=64d251ca&"
import script from "./a-bundle-radio.vue?vue&type=script&lang=js&"
export * from "./a-bundle-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports